import React from "react"
import propTypes from "prop-types"

const Header = ({ children, onClick }) => {
  return (
    <div className="accordion_header">
      <button type="button" onClick={onClick}>
        {children}
      </button>
    </div>
  )
}

Header.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  onClick: propTypes.func
}

Header.defaultProps = {
  onClick: () => {}
}

export default Header
